/* MTO 2026-10-15: ürün slider'ları için mobil noktalı gezinme — ürün galerisi noktalarıyla (tps-gallery-dots)
   aynı görünüm. Bir nokta = bir ekran dolusu kart (mobilde 2'li satırda 12 ürün → 6 nokta); aktif nokta
   kaydırma konumundan bulunur. Liste gerçekten kaymıyorsa (kaydırma kapalı, kartlar sığıyor ya da sekme
   kapalı) gizlenir; görünürlüğü yalnız mobil kırılımda CSS açar (component-slider.css).
   Dekoratif (aria-hidden): kartların kendisi listede klavye/ekran okuyucuyla gezilebilir.
   Kullanım: <tps-slider-dots class="tps-slider-dots" data-for="Slider-…" aria-hidden="true" hidden></tps-slider-dots>
   (data-for yoksa bir önceki kardeş öğe liste sayılır). */
if (!customElements.get('tps-slider-dots')) {
  customElements.define('tps-slider-dots', class TpsSliderDots extends HTMLElement {
    connectedCallback() {
      this.list = (this.dataset.for && document.getElementById(this.dataset.for)) || this.previousElementSibling;
      if (!this.list) return;
      this.queue = this.queue.bind(this);
      this.list.addEventListener('scroll', this.queue, { passive: true });
      // Boyut değişimi (döndürme, sekme açılması, görsellerin yüklenmesi) ve kart listesinin değişmesi.
      this.resizeObserver = new ResizeObserver(this.queue);
      this.resizeObserver.observe(this.list);
      this.mutationObserver = new MutationObserver(this.queue);
      this.mutationObserver.observe(this.list, { childList: true });
      this.sync();
    }

    disconnectedCallback() {
      if (!this.list) return;
      this.list.removeEventListener('scroll', this.queue);
      this.resizeObserver.disconnect();
      this.mutationObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    queue() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    sync() {
      const list = this.list;
      const items = Array.from(list.children).filter((el) => el.offsetWidth > 0);
      const max = list.scrollWidth - list.clientWidth;
      if (items.length < 2 || max < 2) {
        this.hidden = true;
        return;
      }
      const step = items[1].offsetLeft - items[0].offsetLeft || items[0].offsetWidth;
      const perView = Math.max(1, Math.round(list.clientWidth / step));
      const pages = Math.ceil((items.length - perView) / perView) + 1;
      if (this.children.length !== pages) {
        this.replaceChildren(...Array.from({ length: pages }, () => document.createElement('i')));
      }
      this.hidden = pages < 2;
      const pos = Math.abs(list.scrollLeft);
      const index = pos >= max - 2 ? pages - 1 : Math.min(pages - 1, Math.round(pos / (step * perView)));
      Array.from(this.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
  });
}
